export default "__VITE_ASSET__2Xv9J6aS__"